export default __webpack_public_path__ + "images/90822c130831105cfea695f2ebaa473c-Industry-Bold.woff2";